var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPackageSearchIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838F",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16 17.333v9.765c0 .399 0 .598-.129.67-.129.071-.298-.035-.636-.246L6.273 21.92c-.46-.287-.689-.431-.814-.657-.126-.226-.126-.497-.126-1.04v-9.557M16 17.333 5.333 10.667M16 17.333l7.953-4.97c1.218-.761 1.827-1.142 1.827-1.696 0-.555-.61-.935-1.827-1.696L17.06 4.663c-.515-.323-.773-.484-1.06-.484s-.545.161-1.06.483l-9.607 6.005"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#77838F",
  d: "M25.667 16.003a1 1 0 0 0 2 0h-2m.06-5.921-.53.848zm.814.657.875-.485zm.126 1.039h-1v4.225h2v-4.225zm-.94-1.696.53-.848-4.394-2.746-.53.848-.53.848 4.394 2.746zm.94 1.696h1c0-.252 0-.511-.02-.733a2 2 0 0 0-.231-.791l-.875.485-.874.484c-.027-.048-.02-.072-.012.012.01.105.012.253.012.543zm-.94-1.696-.53.848c.245.153.37.232.454.297.067.051.043.045.016-.004l.874-.484.875-.485a2 2 0 0 0-.548-.615c-.178-.135-.397-.272-.611-.405z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 23.333,
  cy: 21.997,
  r: 3.333,
  stroke: "#77838F",
  strokeWidth: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838F",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m28 26.664-2-2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#77838F",
  d: "M19.197 27.179a1 1 0 0 0-1.06-1.696l.53.848zm-4.257.156.53-.848-4.273-2.67-.53.847-.53.848 4.273 2.67zm2.393-.17-.53-.849-.273.17.53.849.53.848.273-.17zm1.334-.834-.53-.848-.667.416.53.848.53.848.667-.416zm-.667.416-.53-.848-.667.417.53.848.53.848.667-.417zm-3.06.588-.53.848c.24.15.484.304.707.413.243.119.534.222.883.222v-2c.063 0 .081.023-.005-.019a7 7 0 0 1-.525-.312zm2.12 0-.53-.848c-.275.172-.418.26-.525.312-.086.042-.068.02-.005.02v2c.35 0 .64-.104.884-.223.222-.109.466-.263.706-.413z"
})));
export default SvgPackageSearchIcon;